/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Competency,
  CompetencyReadonly,
  CompetencyRequest,
  PaginatedCompetencyReadonlyList,
  PatchedCompetencyRequest,
  PatchedSkillRequest,
  Skill,
  SkillByCategoryUnionReadonly,
  SkillByPositionGroup,
  SkillListItemReadonly,
  SkillMatchRequestRequest,
  SkillMatchResponse,
  SkillRequest,
  SkillsCompetenciesListParams,
  SkillsListParams,
  SkillsRetrieveParams,
  SkillsV2ListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSkillsListUrl = (params?: SkillsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skills/?${stringifiedParams}` : `/api/skills/`
}

/**
 * List and manage skills (job types such as Server, Bartender, Cook).
 *
 * Includes optional wage defaults and recommendations.
 */
export const skillsList = async (params?: SkillsListParams, options?: Parameters<typeof customFetch>[1]): Promise<SkillListItemReadonly[]> => {

  return customFetch<SkillListItemReadonly[]>(getSkillsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsListQueryKey = (params?: SkillsListParams,) => {
    return [
    `/api/skills/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsListQueryOptions = <TData = Awaited<ReturnType<typeof skillsList>>, TError = void>(params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsList>>> = ({ signal }) => skillsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsList>>>
export type SkillsListQueryError = void


export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = void>(
 params: undefined |  SkillsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsList>>,
          TError,
          Awaited<ReturnType<typeof skillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = void>(
 params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsList>>,
          TError,
          Awaited<ReturnType<typeof skillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = void>(
 params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = void>(
 params?: SkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsCreateUrl = () => {




  return `/api/skills/`
}

/**
 * List and manage skills (job types such as Server, Bartender, Cook).
 *
 * Includes optional wage defaults and recommendations.
 */
export const skillsCreate = async (skillRequest: SkillRequest, options?: Parameters<typeof customFetch>[1]): Promise<Skill> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Skill>(getSkillsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skillRequest)
  }
);}





export const getSkillsCreateMutationKey = () => ['skillsCreate'] as const;

export const getSkillsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCreate>>, TError,SkillsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsCreate>>, TError,SkillsCreateMutationVariables, TContext> => {

const mutationKey = getSkillsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsCreate>>, SkillsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  skillsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsCreate>>>
    export type SkillsCreateMutationBody = SkillRequest
    export type SkillsCreateMutationError = void
    export type SkillsCreateMutationVariables = {data: SkillRequest}

    export const useSkillsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCreate>>, TError,SkillsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsCreate>>,
        TError,
        SkillsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsCreateMutationOptions(options), queryClient);
    }
    export const getSkillsRetrieveUrl = (id: number,
    params?: SkillsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skills/${id}/?${stringifiedParams}` : `/api/skills/${id}/`
}

/**
 * List and manage skills (job types such as Server, Bartender, Cook).
 *
 * Includes optional wage defaults and recommendations.
 */
export const skillsRetrieve = async (id: number,
    params?: SkillsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<SkillListItemReadonly> => {

  return customFetch<SkillListItemReadonly>(getSkillsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsRetrieveQueryKey = (id: number,
    params?: SkillsRetrieveParams,) => {
    return [
    `/api/skills/${id}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = void>(id: number,
    params?: SkillsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRetrieve>>> = ({ signal }) => skillsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRetrieve>>>
export type SkillsRetrieveQueryError = void


export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = void>(
 id: number,
    params: undefined |  SkillsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = void>(
 id: number,
    params?: SkillsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = void>(
 id: number,
    params?: SkillsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = void>(
 id: number,
    params?: SkillsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsUpdateUrl = (id: number,) => {




  return `/api/skills/${id}/`
}

/**
 * List and manage skills (job types such as Server, Bartender, Cook).
 *
 * Includes optional wage defaults and recommendations.
 */
export const skillsUpdate = async (id: number,
    skillRequest: SkillRequest, options?: Parameters<typeof customFetch>[1]): Promise<Skill> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Skill>(getSkillsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skillRequest)
  }
);}





export const getSkillsUpdateMutationKey = () => ['skillsUpdate'] as const;

export const getSkillsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError,SkillsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError,SkillsUpdateMutationVariables, TContext> => {

const mutationKey = getSkillsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsUpdate>>, SkillsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  skillsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsUpdate>>>
    export type SkillsUpdateMutationBody = SkillRequest
    export type SkillsUpdateMutationError = void
    export type SkillsUpdateMutationVariables = {id: number;data: SkillRequest}

    export const useSkillsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsUpdate>>, TError,SkillsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsUpdate>>,
        TError,
        SkillsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsUpdateMutationOptions(options), queryClient);
    }
    export const getSkillsPartialUpdateUrl = (id: number,) => {




  return `/api/skills/${id}/`
}

/**
 * List and manage skills (job types such as Server, Bartender, Cook).
 *
 * Includes optional wage defaults and recommendations.
 */
export const skillsPartialUpdate = async (id: number,
    patchedSkillRequest?: PatchedSkillRequest, options?: Parameters<typeof customFetch>[1]): Promise<Skill> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Skill>(getSkillsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedSkillRequest)
  }
);}





export const getSkillsPartialUpdateMutationKey = () => ['skillsPartialUpdate'] as const;

export const getSkillsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsPartialUpdate>>, TError,SkillsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsPartialUpdate>>, TError,SkillsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getSkillsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsPartialUpdate>>, SkillsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  skillsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsPartialUpdate>>>
    export type SkillsPartialUpdateMutationBody = PatchedSkillRequest | undefined
    export type SkillsPartialUpdateMutationError = void
    export type SkillsPartialUpdateMutationVariables = {id: number;data?: PatchedSkillRequest}

    export const useSkillsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsPartialUpdate>>, TError,SkillsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsPartialUpdate>>,
        TError,
        SkillsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getSkillsCompetenciesListUrl = (params?: SkillsCompetenciesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skills/competencies/?${stringifiedParams}` : `/api/skills/competencies/`
}

/**
 * List and manage competencies (sub-skills within a skill, e.g. 'Wine Service' under 'Server').
 */
export const skillsCompetenciesList = async (params?: SkillsCompetenciesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedCompetencyReadonlyList> => {

  return customFetch<PaginatedCompetencyReadonlyList>(getSkillsCompetenciesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsCompetenciesListInfiniteQueryKey = (params?: SkillsCompetenciesListParams,) => {
    return [
    'infinite', `/api/skills/competencies/`, ...(params ? [params] : [])
    ] as const;
    }

export const getSkillsCompetenciesListQueryKey = (params?: SkillsCompetenciesListParams,) => {
    return [
    `/api/skills/competencies/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsCompetenciesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof skillsCompetenciesList>>, SkillsCompetenciesListParams['page']>, TError = void>(params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData, QueryKey, SkillsCompetenciesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsCompetenciesListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsCompetenciesList>>, QueryKey, SkillsCompetenciesListParams['page']> = ({ signal, pageParam }) => skillsCompetenciesList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData, QueryKey, SkillsCompetenciesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsCompetenciesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof skillsCompetenciesList>>>
export type SkillsCompetenciesListInfiniteQueryError = void


export function useSkillsCompetenciesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof skillsCompetenciesList>>, SkillsCompetenciesListParams['page']>, TError = void>(
 params: undefined |  SkillsCompetenciesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData, QueryKey, SkillsCompetenciesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCompetenciesList>>,
          TError,
          Awaited<ReturnType<typeof skillsCompetenciesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCompetenciesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof skillsCompetenciesList>>, SkillsCompetenciesListParams['page']>, TError = void>(
 params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData, QueryKey, SkillsCompetenciesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCompetenciesList>>,
          TError,
          Awaited<ReturnType<typeof skillsCompetenciesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCompetenciesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof skillsCompetenciesList>>, SkillsCompetenciesListParams['page']>, TError = void>(
 params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData, QueryKey, SkillsCompetenciesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsCompetenciesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof skillsCompetenciesList>>, SkillsCompetenciesListParams['page']>, TError = void>(
 params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData, QueryKey, SkillsCompetenciesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsCompetenciesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsCompetenciesListQueryOptions = <TData = Awaited<ReturnType<typeof skillsCompetenciesList>>, TError = void>(params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsCompetenciesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsCompetenciesList>>> = ({ signal }) => skillsCompetenciesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsCompetenciesListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsCompetenciesList>>>
export type SkillsCompetenciesListQueryError = void


export function useSkillsCompetenciesList<TData = Awaited<ReturnType<typeof skillsCompetenciesList>>, TError = void>(
 params: undefined |  SkillsCompetenciesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCompetenciesList>>,
          TError,
          Awaited<ReturnType<typeof skillsCompetenciesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCompetenciesList<TData = Awaited<ReturnType<typeof skillsCompetenciesList>>, TError = void>(
 params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCompetenciesList>>,
          TError,
          Awaited<ReturnType<typeof skillsCompetenciesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCompetenciesList<TData = Awaited<ReturnType<typeof skillsCompetenciesList>>, TError = void>(
 params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsCompetenciesList<TData = Awaited<ReturnType<typeof skillsCompetenciesList>>, TError = void>(
 params?: SkillsCompetenciesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsCompetenciesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsCompetenciesCreateUrl = () => {




  return `/api/skills/competencies/`
}

/**
 * List and manage competencies (sub-skills within a skill, e.g. 'Wine Service' under 'Server').
 */
export const skillsCompetenciesCreate = async (competencyRequest: CompetencyRequest, options?: Parameters<typeof customFetch>[1]): Promise<Competency> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Competency>(getSkillsCompetenciesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(competencyRequest)
  }
);}





export const getSkillsCompetenciesCreateMutationKey = () => ['skillsCompetenciesCreate'] as const;

export const getSkillsCompetenciesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesCreate>>, TError,SkillsCompetenciesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesCreate>>, TError,SkillsCompetenciesCreateMutationVariables, TContext> => {

const mutationKey = getSkillsCompetenciesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsCompetenciesCreate>>, SkillsCompetenciesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  skillsCompetenciesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsCompetenciesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsCompetenciesCreate>>>
    export type SkillsCompetenciesCreateMutationBody = CompetencyRequest
    export type SkillsCompetenciesCreateMutationError = void
    export type SkillsCompetenciesCreateMutationVariables = {data: CompetencyRequest}

    export const useSkillsCompetenciesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesCreate>>, TError,SkillsCompetenciesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsCompetenciesCreate>>,
        TError,
        SkillsCompetenciesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsCompetenciesCreateMutationOptions(options), queryClient);
    }
    export const getSkillsCompetenciesRetrieveUrl = (id: number,) => {




  return `/api/skills/competencies/${id}/`
}

/**
 * List and manage competencies (sub-skills within a skill, e.g. 'Wine Service' under 'Server').
 */
export const skillsCompetenciesRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<CompetencyReadonly> => {

  return customFetch<CompetencyReadonly>(getSkillsCompetenciesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsCompetenciesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/skills/competencies/${id}/`
    ] as const;
    }


export const getSkillsCompetenciesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsCompetenciesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>> = ({ signal }) => skillsCompetenciesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsCompetenciesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>>
export type SkillsCompetenciesRetrieveQueryError = void


export function useSkillsCompetenciesRetrieve<TData = Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCompetenciesRetrieve<TData = Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsCompetenciesRetrieve<TData = Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsCompetenciesRetrieve<TData = Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsCompetenciesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsCompetenciesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsCompetenciesUpdateUrl = (id: number,) => {




  return `/api/skills/competencies/${id}/`
}

/**
 * List and manage competencies (sub-skills within a skill, e.g. 'Wine Service' under 'Server').
 */
export const skillsCompetenciesUpdate = async (id: number,
    competencyRequest: CompetencyRequest, options?: Parameters<typeof customFetch>[1]): Promise<Competency> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Competency>(getSkillsCompetenciesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(competencyRequest)
  }
);}





export const getSkillsCompetenciesUpdateMutationKey = () => ['skillsCompetenciesUpdate'] as const;

export const getSkillsCompetenciesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesUpdate>>, TError,SkillsCompetenciesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesUpdate>>, TError,SkillsCompetenciesUpdateMutationVariables, TContext> => {

const mutationKey = getSkillsCompetenciesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsCompetenciesUpdate>>, SkillsCompetenciesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  skillsCompetenciesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsCompetenciesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsCompetenciesUpdate>>>
    export type SkillsCompetenciesUpdateMutationBody = CompetencyRequest
    export type SkillsCompetenciesUpdateMutationError = void
    export type SkillsCompetenciesUpdateMutationVariables = {id: number;data: CompetencyRequest}

    export const useSkillsCompetenciesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesUpdate>>, TError,SkillsCompetenciesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsCompetenciesUpdate>>,
        TError,
        SkillsCompetenciesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsCompetenciesUpdateMutationOptions(options), queryClient);
    }
    export const getSkillsCompetenciesPartialUpdateUrl = (id: number,) => {




  return `/api/skills/competencies/${id}/`
}

/**
 * List and manage competencies (sub-skills within a skill, e.g. 'Wine Service' under 'Server').
 */
export const skillsCompetenciesPartialUpdate = async (id: number,
    patchedCompetencyRequest?: PatchedCompetencyRequest, options?: Parameters<typeof customFetch>[1]): Promise<Competency> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Competency>(getSkillsCompetenciesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCompetencyRequest)
  }
);}





export const getSkillsCompetenciesPartialUpdateMutationKey = () => ['skillsCompetenciesPartialUpdate'] as const;

export const getSkillsCompetenciesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesPartialUpdate>>, TError,SkillsCompetenciesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesPartialUpdate>>, TError,SkillsCompetenciesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getSkillsCompetenciesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsCompetenciesPartialUpdate>>, SkillsCompetenciesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  skillsCompetenciesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsCompetenciesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsCompetenciesPartialUpdate>>>
    export type SkillsCompetenciesPartialUpdateMutationBody = PatchedCompetencyRequest | undefined
    export type SkillsCompetenciesPartialUpdateMutationError = void
    export type SkillsCompetenciesPartialUpdateMutationVariables = {id: number;data?: PatchedCompetencyRequest}

    export const useSkillsCompetenciesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsCompetenciesPartialUpdate>>, TError,SkillsCompetenciesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsCompetenciesPartialUpdate>>,
        TError,
        SkillsCompetenciesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsCompetenciesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getSkillsMatchCreateUrl = () => {




  return `/api/skills/match/`
}

/**
 * Map a free-form role/position name to a Sidegig Skill.
 *
 * Gated to the `job_crawler` service group — the job-crawler service uses
 * this per scraped job to resolve `(position_name, description?) → skill_id`.
 * Not exposed to end users.
 *
 * Returns a hit `{skill_id, skill_name, confidence}` when the LLM picks an
 * active catalog Skill, or a miss `{skill_id: null, skill_name: null,
 * confidence: 0.0}` when the LLM picks something not in the active catalog
 * (or the catalog is empty). The view applies no confidence threshold —
 * callers decide what counts as a good enough match.
 */
export const skillsMatchCreate = async (skillMatchRequestRequest: SkillMatchRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<SkillMatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SkillMatchResponse>(getSkillsMatchCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skillMatchRequestRequest)
  }
);}





export const getSkillsMatchCreateMutationKey = () => ['skillsMatchCreate'] as const;

export const getSkillsMatchCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsMatchCreate>>, TError,SkillsMatchCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skillsMatchCreate>>, TError,SkillsMatchCreateMutationVariables, TContext> => {

const mutationKey = getSkillsMatchCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsMatchCreate>>, SkillsMatchCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  skillsMatchCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkillsMatchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsMatchCreate>>>
    export type SkillsMatchCreateMutationBody = SkillMatchRequestRequest
    export type SkillsMatchCreateMutationError = void
    export type SkillsMatchCreateMutationVariables = {data: SkillMatchRequestRequest}

    export const useSkillsMatchCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skillsMatchCreate>>, TError,SkillsMatchCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skillsMatchCreate>>,
        TError,
        SkillsMatchCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSkillsMatchCreateMutationOptions(options), queryClient);
    }
    export const getSkillsPositionsListUrl = () => {




  return `/api/skills/positions/`
}

export const skillsPositionsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<SkillByPositionGroup[]> => {

  return customFetch<SkillByPositionGroup[]>(getSkillsPositionsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsPositionsListQueryKey = () => {
    return [
    `/api/skills/positions/`
    ] as const;
    }


export const getSkillsPositionsListQueryOptions = <TData = Awaited<ReturnType<typeof skillsPositionsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsPositionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsPositionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsPositionsList>>> = ({ signal }) => skillsPositionsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsPositionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsPositionsListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsPositionsList>>>
export type SkillsPositionsListQueryError = void


export function useSkillsPositionsList<TData = Awaited<ReturnType<typeof skillsPositionsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsPositionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsPositionsList>>,
          TError,
          Awaited<ReturnType<typeof skillsPositionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsPositionsList<TData = Awaited<ReturnType<typeof skillsPositionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsPositionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsPositionsList>>,
          TError,
          Awaited<ReturnType<typeof skillsPositionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsPositionsList<TData = Awaited<ReturnType<typeof skillsPositionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsPositionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSkillsPositionsList<TData = Awaited<ReturnType<typeof skillsPositionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsPositionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsPositionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsV2ListUrl = (params?: SkillsV2ListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/skills/v2/?${stringifiedParams}` : `/api/skills/v2/`
}

/**
 * This API will list the list of skills by category, by default only show the active skills.
 * @deprecated
 */
export const skillsV2List = async (params?: SkillsV2ListParams, options?: Parameters<typeof customFetch>[1]): Promise<SkillByCategoryUnionReadonly[]> => {

  return customFetch<SkillByCategoryUnionReadonly[]>(getSkillsV2ListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsV2ListQueryKey = (params?: SkillsV2ListParams,) => {
    return [
    `/api/skills/v2/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkillsV2ListQueryOptions = <TData = Awaited<ReturnType<typeof skillsV2List>>, TError = void>(params?: SkillsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2List>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsV2ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsV2List>>> = ({ signal }) => skillsV2List(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsV2List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsV2ListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsV2List>>>
export type SkillsV2ListQueryError = void


export function useSkillsV2List<TData = Awaited<ReturnType<typeof skillsV2List>>, TError = void>(
 params: undefined |  SkillsV2ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2List>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsV2List>>,
          TError,
          Awaited<ReturnType<typeof skillsV2List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsV2List<TData = Awaited<ReturnType<typeof skillsV2List>>, TError = void>(
 params?: SkillsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2List>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsV2List>>,
          TError,
          Awaited<ReturnType<typeof skillsV2List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsV2List<TData = Awaited<ReturnType<typeof skillsV2List>>, TError = void>(
 params?: SkillsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2List>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useSkillsV2List<TData = Awaited<ReturnType<typeof skillsV2List>>, TError = void>(
 params?: SkillsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2List>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsV2ListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSkillsV2RetrieveUrl = (id: number,) => {




  return `/api/skills/v2/${id}/`
}

/**
 * This API will list the list of skills by category, by default only show the active skills.
 * @deprecated
 */
export const skillsV2Retrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<SkillByCategoryUnionReadonly> => {

  return customFetch<SkillByCategoryUnionReadonly>(getSkillsV2RetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsV2RetrieveQueryKey = (id: number,) => {
    return [
    `/api/skills/v2/${id}/`
    ] as const;
    }


export const getSkillsV2RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof skillsV2Retrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsV2RetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsV2Retrieve>>> = ({ signal }) => skillsV2Retrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsV2Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsV2RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof skillsV2Retrieve>>>
export type SkillsV2RetrieveQueryError = void


export function useSkillsV2Retrieve<TData = Awaited<ReturnType<typeof skillsV2Retrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsV2Retrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsV2Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsV2Retrieve<TData = Awaited<ReturnType<typeof skillsV2Retrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsV2Retrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsV2Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsV2Retrieve<TData = Awaited<ReturnType<typeof skillsV2Retrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useSkillsV2Retrieve<TData = Awaited<ReturnType<typeof skillsV2Retrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsV2Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsV2RetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






